import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ClaimsTopLevelNavigation = ({ accountType }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const isAll = location.pathname.includes('all_claim_groups') || location.pathname.includes('all_claims');

  return (
    <Nav variant="tabs" className="mb-0">
      <Nav.Item>
        <Nav.Link
          as={Link}
          active={!isAll}
          to={`/${accountType}/my_claim_groups/`}
        >
          {t('my') || 'My'}
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          active={isAll}
          to={`/${accountType}/all_claim_groups/`}
        >
          {t('all') || 'All'}
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default ClaimsTopLevelNavigation;
